import styled from '@emotion/styled';

export const StyledPaymentIcons = styled.ul<{ center?: boolean }>(({ theme, center }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spaces[3],
    justifyContent: center ? 'center' : 'flex-start',
}));
